export default "__VITE_ASSET__Bxc0Yzsx__"